module.exports = __webpack_public_path__ + "assets/asset-d2840f29a70cbbb56434610143721033.svg";